module.exports = __webpack_public_path__ + "img/voice.646ebfdd.gif";